import axios from "axios";
import { convertObjectToUrlParams } from "../helpers/convertObjToUrlParams";

export interface PersonalCatchReport {
  userID?: number;
  beginDate?: string;
  endDate?: string;
  lakeID?: number;
  gearID?: number;
  gridID?: number;
  speciesID?: number;
  mgmtUnitID?: number;
}

export const getPersonalCatchReport = async (params: PersonalCatchReport) => {
  try {
    const response = await axios.get(
      `${
        process.env.REACT_APP_API
      }/Report/PersonalCatch${convertObjectToUrlParams(params)}`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
